<template>
  <div class="default-slide-view">
    <h2 class="default-slide-view__title">Which slide would you like to create?</h2>
    <div class="default-slide-view__content">
      <div class="flex flex-wrap justify-center gap-x-10 gap-y-10">
        <EditorViewerButton variant="dark" size="lg" borderless="borderless" @click="$emit('create-slide', 'P')">
          <IconsPDFSlideIcon class="transform scale-95 w-10" /><span>PDF</span></EditorViewerButton
        >
        <EditorViewerButton variant="dark" size="lg" borderless="borderless" @click="$emit('create-slide', 'M')">
          <IconsThreeDSlideIcon class="transform scale-95 w-10" /><span>3D</span></EditorViewerButton
        >
        <EditorViewerButton variant="dark" size="lg" borderless="borderless" @click="$emit('create-slide', 'S')">
          <IconsThreeSixtySlideIcon class="transform scale-95 w-10" /><span>360</span></EditorViewerButton
        >
        <EditorViewerButton variant="dark" size="lg" borderless="borderless" @click="$emit('create-slide', 'E')">
          <IconsMeetingSlideIcon class="transform scale-95 w-8" /><span>Meeting booking</span></EditorViewerButton
        >
        <EditorViewerButton variant="dark" size="lg" borderless="borderless" @click="$emit('create-slide', 'I')">
          <IconsImageSlideIcon class="transform scale-95 w-10" /><span>Image</span></EditorViewerButton
        >
        <EditorViewerButton variant="dark" size="lg" borderless="borderless" @click="$emit('create-slide', 'V')">
          <FilmIcon class="w-10" /><span>Video</span></EditorViewerButton
        >
      </div>
      <div v-if="isInternalAdmin" class="flex justify-center px-8">
        <VButton class="w-full text-left" variant="gold" size="sm" @click="$emit('create-slide', 'D')">
          <CodeBracketIcon class="w-6 inline-block transform scale-95 mr-3" /><span>URL</span></VButton
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CodeBracketIcon } from '@heroicons/vue/24/solid'
import { FilmIcon } from '@heroicons/vue/24/outline'
import IconsPDFSlideIcon from '@/components/icons/PDFSlideIcon.svg'
import IconsThreeDSlideIcon from '@/components/icons/ThreeDSlideIcon.svg'
import IconsThreeSixtySlideIcon from '@/components/icons/ThreeSixtySlideIcon.svg'
import IconsMeetingSlideIcon from '@/components/icons/MeetingSlideIcon.svg'
import IconsImageSlideIcon from '@/components/icons/ImageSlideIcon.svg'

defineProps({
  isInternalAdmin: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['create-slide'])
</script>

<style lang="stylus" scoped>
.default-slide-view
  @apply h-full flex flex-col items-center justify-center bg-gray-800 text-white
  &__title
    @apply mb-0 text-3xl lg_text-4xl font-normal
  &__content
    @apply flex flex-col justify-center max-w-2xl gap-y-10 mt-8 lg_mt-16
</style>
